import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo8 } from "../../../routes/Module8";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo8/marcar.png";
import Imagen2 from "../../../images/modulo8/llegar.png";
import Imagen3 from "../../../images/modulo8/buscar.png";
import Imagen4 from "../../../images/modulo8/huella.png";
import Imagen5 from "../../../images/modulo8/camara.png";
import Imagen6 from "../../../images/modulo8/votar.png";
import GuiaDocente from "../../../components/GuiaDocente";
import Modulo8Act2 from "../../../DnD/modulo8Act2";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo8/Actividad 2.mp3";

const Actividad2 = () => {
  const infoUnidad = modulo8.content[0];
  const infoAct = modulo8.content[0].activities[1];
  const crumbs = [
    {
      title: modulo8.title,
      url: "/" + modulo8.url,
    },
    {
      title:
        modulo8.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo8.content[0].activities[2].name}`,
    linkNext: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[2].path}`,
    titlePrev: `${modulo8.content[0].activities[0].name}`,
    linkPrev: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[0].path}`,
  };

  const metadata = {
    color: modulo8.color,
    title: `${modulo8.title} - ${infoAct.name}`,
    name: modulo8.title,
  };

  const items = [
    <div className="p-3">
      <img src={Imagen1} alt="Inicio" className="img-fluid mb-2" />
      <p>
        Marcamos la opción elegida con una cruz o aspa en la cédula.
        <br />
        <br />
      </p>
    </div>,
    <div className="p-3">
      <img src={Imagen2} alt="Inicio" className="img-fluid mb-2" />
      <p>
        Llegamos a votar con nuestro DNI.
        <br />
        <br />
        <br />
      </p>
    </div>,
    <div className="p-3">
      <img src={Imagen3} alt="Inicio" className="img-fluid mb-2" />
      <p>
        Buscamos dónde nos toca votar en las listas publicadas en los locales de
        votación.
      </p>
    </div>,
    <div className="p-3">
      <img src={Imagen4} alt="Inicio" className="img-fluid mb-2" />
      <p>Firmamos y colocamos nuestra huella con los miembros de mesa.</p>
    </div>,
    <div className="p-3">
      <img src={Imagen5} alt="Inicio" className="img-fluid mb-2" />
      <p>
        Entramos a la cámara secreta.
        <br />
        <br />
      </p>
    </div>,
    <div className="p-3">
      <img src={Imagen6} alt="Inicio" className="img-fluid mb-2" />
      <p>Depositamos nuestro voto en el ánfora.</p>
    </div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo8.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-12 mb-1">
          <ul className="mb-5">
            <li>
              Cuando votamos, seguimos una serie de pasos. Observa las imágenes.
            </li>
            <li>
              Pon en orden los pasos para votar arrastrando las imagenes a los
              recuadros numerados del 1 al 6 (el 1 debe ser el primer paso y el
              6 el último).
            </li>
          </ul>
        </div>
      </div>
      <Modulo8Act2 items={items} />
      <div>
        <p>
          En las elecciones recientes del Perú se ha empezado a implementar el{" "}
          <strong>voto electrónico</strong>. Este tipo de voto emplea medios
          informáticos para la emisión del voto y permite hacer más simple el
          proceso durante la jornada electoral y al momento del conteo. Es una
          alternativa segura, accesible y confiable.
        </p>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes, lean las descripciones y
          ayude a identificar las situaciones. El orden es el siguiente:
          llegamos a votar con el DNI, buscamos dónde votar, entramos a la
          cámara secreta, marcamos la opción elegida, depositamos el voto en el
          ánfora y firmamos.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
